import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PolicyTrackerData } from "../policy-tracker.interfaces";
import { StateBadge, TrackerState } from "../policy-status.constants";

@Component({
  selector: "app-policy-tracker-header",
  imports: [CommonModule],
  templateUrl: "./policy-tracker-header.component.html",
  styleUrls: ["./policy-tracker-header.component.scss"],
})
export class PolicyTrackerHeaderComponent {
  @Input() policy!: PolicyTrackerData;
  @Input() state: TrackerState = "in_review";

  readonly badges = StateBadge;
}
